import FormFields from './FormFields';
import OverviewSection from './OverviewSection';
import ReservationData from './ReservationData';
import { calculatePrice } from './utils';

const getReservationLabel = (reservation) => {
    let adults = parseInt(reservation.adults_count) || 0;
    let children = parseInt(reservation.children_count) || 0;
    let totalPeople = adults + children;

    let peopleText = totalPeople > 0 ? `${totalPeople}os` : '';

    let clientText = reservation.client?.name ?
        reservation.client.name :
        reservation.client?.phone ?
            reservation.client.phone :
            reservation.client?.email;

    return `${peopleText} ${clientText}`;
};

const getDayHeaderStats = (reservations) => {
    let totalPeople = 0;

    reservations.forEach(reservation => {
        if (reservation && reservation.status !== 'canceled') {
            let adults = parseInt(reservation.adults_count) || 0;
            let children = parseInt(reservation.children_count) || 0;
            totalPeople += (adults + children);
        }
    });

    return {
        primary: `${totalPeople}os`,
        secondary: null
    };
};

export {
    FormFields,
    OverviewSection,
    ReservationData,
    calculatePrice,
    getReservationLabel,
    getDayHeaderStats
};

export const defaults = {
    type_of_stay: 'night',
    adults_count: 0,
    children_count: 0,
    tents_count: 0,
    cars_count: 0,
    caravans_count: 0,
    note: ""
};
